import * as React from "react";

function SvgIconFilterCubeOffset(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.58 0H0V6.581h2.742V2.74H6.58V0zm20.84 0H34V6.581h-2.742V2.74H27.42V0zM6.58 34H0V27.419h2.742v3.84H6.58V34zm20.84 0H34V27.419h-2.742v3.84H27.42V34zM9.994 15.521H6.901l2.704 2.704h3.093l-2.704-2.704zm6.125 2.704h1.598l-1.598-1.37v1.37zm-7.415.45L6 15.973v7.661l2.704 2.704v-7.661zm9.013.451H9.605v7.662h8.112v-7.662zm-2.253 4.056a1.803 1.803 0 11-3.605 0 1.803 1.803 0 013.605 0zm.901 0a2.704 2.704 0 11-5.408 0 2.704 2.704 0 015.408 0z"
        fill="#414042"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.695 7h7.66l3.155 2.704h-8.112L11.696 7zm-.902.45l2.704 2.705v7.66l-2.704-2.703V7.45zm3.606 3.155h8.111v7.661h-8.112v-7.66zm4.055 5.859a1.803 1.803 0 100-3.606 1.803 1.803 0 000 3.606zm0 .901a2.704 2.704 0 100-5.408 2.704 2.704 0 000 5.408zM17.184 15.521zm1.23 3.604h.573v7.212l-.574-.574v-6.639zm5.055-.9v-2.704h1.376L28 18.225h-4.53zm-3.58.901H28v7.662h-8.112v-7.662zm4.055 5.859a1.803 1.803 0 100-3.605 1.803 1.803 0 000 3.605zm0 .901a2.704 2.704 0 100-5.408 2.704 2.704 0 000 5.408z"
        fill="#414042"
      />
    </svg>
  );
}

export default SvgIconFilterCubeOffset;
